import React from "react";
import { styled } from "styled-components";

import { Icon } from "../Icon";
import { useTheme } from "../../theme";

export const CloseContainer = styled.div(({ theme }) => {
  return {
    width: 24,
    height: 24,
    borderRadius: theme.radii.round,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#656D75",
    cursor: "pointer",
    background: theme.colors.white,
    boxShadow: theme.shadows.surfaceZ1Light,

    [`& ${Icon.Frame}`]: {
      width: 10,
      height: 10,
    },

    [`&:hover, &:active`]: {
      color: "#2B3239",
    },
  };
});

export const Close: React.FC<React.ComponentProps<typeof CloseContainer>> = ({
  ...props
}) => {
  const { colors } = useTheme();
  return (
    <CloseContainer {...props}>
      <Icon name="close" size={12} color={colors.grayDark} />
    </CloseContainer>
  );
};
